import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons/faInfoCircle';

import { Tooltip } from 'ui-components/components/tooltip';

import { CustomsExportDeclarationNumberInput } from './export-declaration-number-input';
import { CustomsField } from '../customs-field';
import { messages } from '../messages';
import commonStyle from '../common-style.module.less';

export const CustomsExportDeclarationNumber = () => {
  const intl = useIntl();

  const tooltip = (
    <Tooltip position='top' text={intl.formatMessage(messages.exportDeclarationNumberTooltip)}>
      <FontAwesomeIcon icon={faInfoCircle} />
    </Tooltip>
  );

  return (
    <CustomsField label={messages.exportDeclarationNumber} labelClassname={commonStyle['label-with-tooltip']} tooltip={tooltip}>
      <CustomsExportDeclarationNumberInput />
    </CustomsField>
  );
};
